import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  DeleteAccountRequestSchema,
  AccountScanSummaryResponseSchema,
  DataExportResponseSchema,
} from '../schemas/account';
import { defaultErrorResponses } from './errors';

const c = initContract();

export const accountContract = c.router({
  deleteAccount: {
    method: 'DELETE',
    path: '/v1/account',
    body: DeleteAccountRequestSchema,
    responses: {
      204: z.object({}),
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Delete account permanently',
      description: 'Deletes the authenticated user account and associated user-scoped data.',
      errorCodes: ['ACCOUNT_DELETION_FAILED'],
    },
  },
  getScanSummary: {
    method: 'GET',
    path: '/v1/account/scan-summary',
    responses: {
      200: AccountScanSummaryResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Get scan summary stats',
      description: 'Returns dynamic scan summary stats for the signed-in user: emails scanned this month, suggestions applied, senders covered, and successful scans.',
    },
  },
  getDataExport: {
    method: 'GET',
    path: '/v1/account/data-export',
    responses: {
      200: DataExportResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Export all user data (GDPR DSAR)',
      description: 'Returns a JSON bundle of all user-scoped rows so the user can exercise their GDPR data-subject rights (access, portability). OAuth token secrets are redacted.',
    },
  },
});
